import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function Terminal() {
  const [sites, setSites] = useState<any[]>([]);
  const [atgId, setAtgId] = useState('');
  const [fnCode, setFnCode] = useState('I20100');
  const [dataField, setDataField] = useState('');
  const [out, setOut] = useState('');
  const [codes, setCodes] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/api/sites').then(setSites);
    api.get('/api/function-codes').then(setCodes);
  }, []);

  async function send() {
    setBusy(true);
    setOut(o => o + `\n→ ${fnCode}${dataField ? ' ' + dataField : ''}\n`);
    try {
      const res = await api.post(`/api/atgs/${atgId}/poll`, { functionCode: fnCode, dataField: dataField || undefined });
      setOut(o => o + `← format=${res.response.format} fn=${res.response.functionCode} `
        + `cs=${res.response.checksum ?? '—'} valid=${res.response.checksumValid ?? '—'}\n`
        + (res.response.unrecognized ? '⚠ ATG returned 9999 (unrecognized command)\n' : '')
        + res.response.data + '\n'
        + (res.parsed ? '— parsed —\n' + JSON.stringify(res.parsed, null, 2) + '\n' : ''));
    } catch (e: any) {
      setOut(o => o + `✗ ${e.body?.error || e.message}\n`);
    } finally { setBusy(false); }
  }

  const allAtgs = sites.flatMap(s => s.atgs.map((a: any) => ({ id: a.id, label: `${s.name} – ${a.label}` })));

  return (
    <div className="card">
      <h2>Live ATG Terminal</h2>
      <p style={{ color: 'var(--muted)', marginTop: 0 }}>
        Send raw Veeder-Root function codes directly to a console. Frames are wrapped in SOH/ETX automatically.
      </p>
      <div className="row">
        <div className="col">
          <label>ATG</label>
          <select value={atgId} onChange={e => setAtgId(e.target.value)}>
            <option value="">Select…</option>
            {allAtgs.map(a => <option key={a.id} value={a.id}>{a.label}</option>)}
          </select>
        </div>
        <div className="col">
          <label>Function code</label>
          <input value={fnCode} onChange={e => setFnCode(e.target.value.toUpperCase())} maxLength={6} />
          <div style={{ marginTop: 6, color: 'var(--muted)', fontSize: 12 }}>
            Quick: {Object.entries(codes).slice(0, 8).map(([k, v]) => (
              <a key={k} onClick={() => setFnCode(v)} style={{ marginRight: 8, cursor: 'pointer' }}>{v}</a>
            ))}
          </div>
        </div>
        <div className="col">
          <label>Data field (optional)</label>
          <input value={dataField} onChange={e => setDataField(e.target.value)} />
        </div>
      </div>
      <div style={{ marginTop: 12, marginBottom: 12 }}>
        <button disabled={!atgId || busy} onClick={send}>{busy ? 'Sending…' : 'Send'}</button>
        <button className="ghost" style={{ marginLeft: 8 }} onClick={() => setOut('')}>Clear</button>
      </div>
      <div className="term">{out || '// output appears here'}</div>
    </div>
  );
}
